import { useTheme } from '@chakra-ui/react';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Text from '~/common/components/Texts/Text';
import type { HistoricalCalculation } from '~/pages/IncomeCalculator/CalculationHistory/types';

import { REQUEST_REFERENCE_TYPE } from '../enums';
import CalculationSummary from './components/CalculationSummary';
import Card from './styles/Card';

type CalculationCardProps = {
  summary: HistoricalCalculation;
  onClick?: () => unknown;
};

const CalculationCard = ({ summary, onClick }: CalculationCardProps) => {
  const { colors } = useTheme();
  if (
    summary.requestReferenceType !== REQUEST_REFERENCE_TYPE.employmentIncome &&
    summary.requestReferenceType !== REQUEST_REFERENCE_TYPE.rentalIncome
  ) {
    return null;
  }

  return (
    <Card onClick={onClick}>
      <CalculationSummary summary={summary} />
      <Text
        pl={3}
        fontSize="xl"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <FontAwesomeIcon color={colors?.gray[500]} icon={faChevronRight} />
      </Text>
    </Card>
  );
};

export default CalculationCard;
